import { merge } from '@inpart-io/devtools';
import { getDataObjectsModule } from '@inpart-io/devtools-vue';
import { type IMeeting, meetingsManager } from '@inpart-io/padme-iap';

import { store } from '@/store';
import { getSearchModule } from '@/store/base/search/module';

import { actions } from './actions';

const MEETING_MODULE = 'meeting';

const dataObjectModule = getDataObjectsModule<IMeeting>(meetingsManager, 1);
const searchModule = getSearchModule<IMeeting>(meetingsManager);

const meetingModuleInstance = merge<unknown>(dataObjectModule, searchModule, { actions });
store.registerModule(MEETING_MODULE, meetingModuleInstance);

export { MEETING_MODULE };
